import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { IErrorResponse } from '../../interface/error-response.interface';
import { v4 as uuidv4 } from 'uuid';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private _message = new BehaviorSubject<string>('Processing. Please Wait....');
  spinnerMessage$ = this._message.asObservable();

  constructor(private spinner: NgxSpinnerService) {}

  public buildType = environment.buildType;
  public domain = environment.baseUrl;
  public mealDomain = environment.mealUrl;
  public reportDomain = environment.reportUrl;

  // public buildType = 'prod';
  // public domain: string = 'https://upgbd.brac.net/'; // Prod Server
  // public mealDomain = 'https://hub.sensor.buzz/'; // Prod Server

  // public buildType = 'stage';
  // public domain = 'https://upgapstg.brac.net/'; // Staging Server
  // public mealDomain = 'https://hub.sensor.buzz/'; // Staging Server

  // public buildType = 'backup';
  // public domain = 'https://upgbackup.brac.net/'; // Backup Server
  // public mealDomain = 'https://hub.sensor.buzz/'; // Backup Server

  // public buildType = 'dev';
  // public domain = 'https://hub.sensor.buzz/'; // Dev Server
  // public mealDomain = 'https://meal.sensor.buzz/'; // Dev Server

  // public buildType = 'training';
  // public domain = 'https://trainingupg.brac.net/'; // Training Server
  // public mealDomain = 'https://meal.sensor.buzz/'; // Training Server

  public apiURL_UPGAuth: string = this.domain + 'upg-auth/api/v1';
  public apiURL_UPGParticipantSelection: string =
    this.domain + 'upg-participant-selection/api/v1';
  public apiURL_masterdataUpload: string =
    this.domain + 'masterdata-upload/api/v1';
  public apiURL_FormBuilder: string = this.domain + 'form-builder/api';
  public apiURL_CohortConfiguration: string =
    this.domain + 'cohort-configuration/api';
  public apiURL_UPGEnrollment: string = this.domain + 'upg-enrollment/api/v1';
  public apiURL_UPGReports: string = this.reportDomain + 'api/v1';
  public apiURL_UPGNotify: string = this.domain + 'upg-notify/api/v1';
  public apiURL_UPGSupport: string = this.domain + 'upg-support/api/v1';
  public apiURL_UPGMeal: string = this.domain + 'upg-meal/api/v1';
  public apiURL_upg_supervision: string =
    this.domain + 'upg-supervision/api/v1';
  public apiURL_UPGMFTransferWriteOff: string =
    this.domain + 'upg-mf-transfer/api/v1';


  public SSOSiteURL =
    this.buildType == 'dev' ? 'https://school.jogajog.com.bd/' : this.domain;
  public ssoBracUrl =
    this.buildType == 'dev'
      ? 'https://loginstg.brac.net/realms/brac/protocol/openid-connect/auth?client_id=upgweb&response_type=code&state=fj8o3n7bdy1op5&scope=openid&redirect_uri=https://hub.sensor.buzz/upg-auth/api/v1/account/sso/callback'
      : this.buildType == 'stage'
        ? 'https://loginstg.brac.net/realms/brac/protocol/openid-connect/auth?client_id=upgweb&response_type=code&state=fj8o3n7bdy1op5&scope=openid&redirect_uri=https://upgapstg.brac.net/upg-auth/api/v1/account/sso/callback'
        : 'https://login.brac.net/realms/brac/protocol/openid-connect/auth?client_id=upgweb&response_type=code&state=fj8o3n7bdy1op5&scope=openid&redirect_uri=https://upgbd.brac.net/upg-auth/api/v1/account/sso/callback';
  public ssoBracLogoutURL =
    this.buildType == 'dev'
      ? 'https://loginstg.brac.net'
      : this.buildType == 'stage'
        ? 'https://loginstg.brac.net'
        : 'https://login.brac.net';
  public sheetTempleteURL = './assets/sheetTemplate/';
  public optionForm: any = {
    options: [{ name: '', isRequiredSubQuestion: false }],
  };
  public rowSize = 10;

  validationRegex = [
    {
      id: '1',
      value: '^[0-9]*$',
      displayName: 'Numeric',
    },
    {
      id: '2',
      value: '^[a-zA-Z ]*$',
      displayName: 'Alphabet',
    },
    {
      id: '3',
      value: '^[a-zA-Z0-9 ]*$',
      displayName: 'Alphanumeric',
    },
    {
      id: '4',
      value: '^[+-]?(\\d+\\.?\\d*|\\.\\d+)$',
      displayName: 'Decimal',
    },

    // ⭐ Added new ones
    {
      id: '5',
      value: '^[0-9]$',
      displayName: '1 Digit Only',
    },
    {
      id: '6',
      value: '^[0-9]{1,3}$',
      displayName: 'Up to 3 Digits',
    },
    {
      id: '7',
      value: '^[0-9]{1,4}$',
      displayName: 'Up to 4 Digits',
    },
    {
      id: '8',
      value: '^[0-9]{1,7}$',
      displayName: 'Up to 7 Digits',
    },
    {
      id: '9',
      value: '^[0-9]{0,7}$',
      displayName: 'Up to 7 Digits',
    },
    {
      id: '10',
      value: '^[0-9]?$',
      displayName: '1 Digit Only',
    },
    {
      id: '11',
      value: '^[0-9]{1,2}$',
      displayName: '2 Digit Only',
    },
  ];

  validationRegex_forMealFinding = /^[A-Za-z0-9\/\- ]+$/;

  // This is for admin role user only. And use it on ACL Create.
  programId_forAdmin = '79043ea6-9677-11ed-a1eb-0242ac120002';

  showSwal(title: string, message: string, type: any) {
    // type = "success", "error", "warning", "info" or "question"
    // Swal.fire('OPS Sorry', 'Username or Password  not match', 'warning');
    // Swal.fire(title, message, type);
    Swal.fire({
      icon: type,
      title,
      // text: message
      html: message,
      allowOutsideClick: false,
    });
  }

  public showSwalWithToast(
    title: string = 'Success',
    message: string = 'Request successful.',
    type: 'success' | 'error' | 'warning' | 'info' | 'question' = 'success',
    timerProgressBar: boolean = true,
    timer: number = 2000,
    showConfirmButton: boolean = false,
    showCloseButton: boolean = true,
  ) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      showCloseButton: showCloseButton,
      showConfirmButton: showConfirmButton,
      icon: type,
      title,
      html: message,
      allowOutsideClick: false,
      timerProgressBar: timerProgressBar,
      timer: timer,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
        toast.addEventListener('click', () => Swal.close());
      },
    });
  }

  public showSwalWithToast_notification(
    title: string = 'Success',
    message: string = 'Request successful.',
    type: 'success' | 'error' | 'warning' | 'info' | 'question' = 'success',
    timerProgressBar: boolean = true,
    timer: number = 2000,
    showConfirmButton: boolean = false,
    showCloseButton: boolean = true,
  ) {
    Swal.fire({
      toast: true,
      position: 'bottom-start',
      showCloseButton: showCloseButton,
      showConfirmButton: showConfirmButton,
      icon: type,
      title,
      html: message,
      allowOutsideClick: false,
      timerProgressBar: timerProgressBar,
      timer: timer,
      customClass: {
        popup: 'swal-toast-center-icon',
      },
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
        toast.addEventListener('click', () => Swal.close());
      },
    });
  }
  showSpinner(
    boolData: boolean,
    message: string = ' Processing. Please Wait....',
  ) {
    this._message.next(message);
    if (boolData) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

  errorResponseHandler(error: IErrorResponse) {
    if (error.code == 400 || error.code == 404 || error.code == 409) {
      this.showSwal('Warning', error.message, 'warning');
    } else {
      this.showSwal('Warning', 'Something went wrong', 'error');
    }
  }

  dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      const result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  public dynamicSortCaseInsensitive(property?) {
    // let sortOrder = 1;
    // if (property[0] === '-') {
    //   sortOrder = -1;
    //   property = property.substr(1);
    // }
    // return function(a, b) {
    //   const result =
    //     a[property]?.toLowerCase() < b[property]?.toLowerCase()
    //       ? -1
    //       : a[property]?.toLowerCase() > b[property]?.toLowerCase()
    //       ? 1
    //       : 0;
    //   return result * sortOrder;
    // };

    let sortOrder = 1;
    if (property && property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      const valueA = property ? a[property] : a;
      const valueB = property ? b[property] : b;

      const result =
        valueA?.toString().toLowerCase() < valueB?.toString().toLowerCase()
          ? -1
          : valueA?.toString().toLowerCase() > valueB?.toString().toLowerCase()
            ? 1
            : 0;
      return result * sortOrder;
    };
  }

  formattedDate(dateValue: string): string {
    const date = new Date(dateValue);

    // Get year, month, and day part from the date
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', { month: '2-digit' });
    const day = date.toLocaleString('default', { day: '2-digit' });

    // Generate yyyy-mm-dd date string
    const formattedDate = year + '-' + month + '-' + day;

    return formattedDate;
  }

  formattedDateddMMyyyy(dateValue: string): string {
    const date = new Date(dateValue);

    // Get year, month, and day part from the date
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', { month: '2-digit' });
    const day = date.toLocaleString('default', { day: '2-digit' });

    // Generate yyyy-mm-dd date string
    const formattedDate = day + '/' + month + '/' + year;

    return formattedDate;
  }

  createUUID() {
    return uuidv4();
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
//
// dropdown - 0
// text_field - 1
// radio_button 2,
// checkbox 3
// multiple_text_field 4
// label 5
// multi_select 6
// text_area 7
// formula_text_field 8
// date_field 9
// action_date_field 10
// action_text_field 11
// auto_populated_textfield 12
// auto_populated_date 13
// action_radio_field 14
